module.exports = __webpack_public_path__ + "img/card.5fc37e56.png";